import CallFlowDashboard from 'components/powerCallFlow/containers/powerCallFlow';

export const SettingsPhoneEditFlowView = CallFlowDashboard;
